import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "onChange", "editorDidMount"];
import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from '../utils/index.js';
import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import Editor from '../Editor/index.js';

function ControlledEditor(_ref) {
  var providedValue = _ref.value,
      onChange = _ref.onChange,
      editorDidMount = _ref.editorDidMount,
      props = _objectWithoutProperties(_ref, _excluded);

  var editor = useRef(null);
  var listener = useRef(null);
  var value = useRef(providedValue); // to avoid unnecessary updates in `handleEditorModelChange`
  // (that depends on the `current value` and will trigger to update `attachChangeEventListener`,
  // thus, the listener will be disposed and attached again for every value change)
  // the current value is stored in ref (useRef) instead of being a dependency of `handleEditorModelChange`

  value.current = providedValue;
  var handleEditorModelChange = useCallback(function (event) {
    var editorValue = editor.current.getValue();

    if (value.current !== editorValue) {
      var directChange = onChange(event, editorValue);

      if (typeof directChange === 'string' && editorValue !== directChange) {
        editor.current.setValue(directChange);
      }
    }
  }, [onChange]);
  var attachChangeEventListener = useCallback(function () {
    var _editor$current;

    listener.current = (_editor$current = editor.current) === null || _editor$current === void 0 ? void 0 : _editor$current.onDidChangeModelContent(handleEditorModelChange);
  }, [handleEditorModelChange]);
  useEffect(function () {
    attachChangeEventListener();
    return function () {
      var _listener$current;

      return (_listener$current = listener.current) === null || _listener$current === void 0 ? void 0 : _listener$current.dispose();
    };
  }, [attachChangeEventListener]);
  var handleEditorDidMount = useCallback(function (getValue, _editor) {
    editor.current = _editor;
    attachChangeEventListener();
    editorDidMount(getValue, _editor);
  }, [attachChangeEventListener, editorDidMount]);
  return /*#__PURE__*/React.createElement(Editor, _extends({
    value: providedValue,
    editorDidMount: handleEditorDidMount,
    _isControlledMode: true
  }, props));
}

ControlledEditor.propTypes = {
  value: PropTypes.string,
  editorDidMount: PropTypes.func,
  onChange: PropTypes.func
};
ControlledEditor.defaultProps = {
  editorDidMount: noop,
  onChange: noop
};
export default ControlledEditor;